import React, { useEffect } from 'react';

import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@mui/material';

interface IAlertDialogProps {
  title: string;
  body: string | Element;
  agree: string;
  disagree?: string;
  showAlert: boolean;
  setShowAlert: Function;
  handleAgree: Function;
  handleDisagree?: Function;
}

export default function AlertDialog(props: IAlertDialogProps) {
  const { title, body, agree, disagree, showAlert, handleAgree, handleDisagree } = props;

  // Keep typescript happy.
  const localHandleAgree = () => {
    handleAgree();
  }

  // Keep typescript happy.
  const localHandleDisagree = () => {
    if (!!handleDisagree) {
      handleDisagree();
    }
  }

  useEffect(() => {
    const close = (e: any) => {
      if (e.keyCode === 27) {
        if (!!handleDisagree) {
          handleDisagree();
        }
      }
    }
    document.addEventListener('keydown', close)
    return () => document.removeEventListener('keydown', close)
  })

  return (
    <div>
      <Dialog
        data-test="dialog"
        open={showAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableEscapeKeyDown={true}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {body}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {(!!disagree && !!handleDisagree) &&
            <Button onClick={localHandleDisagree} data-test="agree-button" color="primary" autoFocus>
              {disagree}
            </Button>
          }
          <Button onClick={localHandleAgree} data-test="disagree-button" color="primary">
            {agree}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
